export enum DealQueryKeys {
  dealOrgPreferences = "dealOrgPreferences",
  dealUserPreferences = "dealUserPreferences",
}
